(function ($) {
  'use strict';

  $('document').ready(function () {
    if (!$.fn.countdown) {
      return;
    }

    $('.event-countdown').each(function () {
      var start = $(this).data('datetime');
      var markup = $(this).html();
      $(this).countdown(start, function (e) {
        $(this).html(e.strftime(markup));
      });
    });
  });
}).bind(window)(jQuery);
